import React from 'react';

export default function KeyValueTextInputField({
  label,
  fieldName1,
  fieldName2,
  value1,
  value2,
  onInputChange1,
  onInputChange2,
  removeFromList = null,
  lang,
}) {
  return (
    <div className="mb-3 w-100">
      <label htmlFor={fieldName1} className="form-label">
        {label}
      </label>

      {/* First Input Field */}
      <div className="row mb-2">
        <div className="col-sm-2 d-flex align-items-center">
          <label htmlFor={fieldName1} className="form-label mb-0">
            {fieldName1}
          </label>
        </div>
        <div className="col-sm-10">
          <input
            type="text"
            id={fieldName1}
            value={value1}
            onChange={onInputChange1}
            name={fieldName1}
            className="form-control"
          />
        </div>
      </div>

      {/* Second Input Field */}
      <div className="row mb-2">
        <div className="col-sm-2 d-flex align-items-center">
          <label htmlFor={fieldName2} className="form-label mb-0">
            {fieldName2}
          </label>
        </div>
        <div className="col-sm-10">
          <input
            type="text"
            id={fieldName2}
            value={value2}
            onChange={onInputChange2}
            name={fieldName2}
            className="form-control"
          />
        </div>
      </div>

      <small className="form-text text-muted">
        Add a comma (`,`) to separate values.
      </small>

      <div className="remove_button_height d-flex flex-column">
        {removeFromList &&
          (lang == 'ar' ? (
            <button
              type="button"
              className="btn btn-danger mt-2 remove_button_height custom_button_desktop"
              onClick={removeFromList}
            >
              Remove
            </button>
          ) : (
            <></>
          ))}
      </div>
    </div>
  );
}
